// This file is based on the zenreg password input component
// REF: src/global/client/components/atoms/Inputs/Password
// TODO: Move this validation check to the utils package https://github.com/zenbusiness/application-commons/tree/main/packages/utils
export const PASSWORD_MAX_LENGTH = 128;
export const PASSWORD_MIN_LENGTH = 10;

export const PASSWORD_LENGTH_VALIDATION = 'password_length_validation';

export const PASSWORD_UPPERCASE_VALIDATION = 'password_uppercase_validation';

export const PASSWORD_LOWERCASE_VALIDATION = 'password_lowercase_validation';

export const PASSWORD_NUMBER_VALIDATION = 'password_number_validation';

export const PASSWORD_SYMBOL_VALIDATION = 'password_symbol_validation';

const VALIDATIONS = [
  PASSWORD_LENGTH_VALIDATION,
  PASSWORD_UPPERCASE_VALIDATION,
  PASSWORD_LOWERCASE_VALIDATION,
  PASSWORD_NUMBER_VALIDATION,
  PASSWORD_SYMBOL_VALIDATION
];

const termNamespace = 'shopping.page.checkout.account.form.field.password.error.invalid';
export const ERROR_KEY_TO_TERM_MAP = {
  [PASSWORD_LENGTH_VALIDATION]: `${termNamespace}.length`,
  [PASSWORD_UPPERCASE_VALIDATION]: `${termNamespace}.uppercase`,
  [PASSWORD_LOWERCASE_VALIDATION]: `${termNamespace}.lowercase`,
  [PASSWORD_NUMBER_VALIDATION]: `${termNamespace}.number`,
  [PASSWORD_SYMBOL_VALIDATION]: `${termNamespace}.symbol`
};

const uppercaseRegexp = /[A-Z]+/;
const lowercaseRegexp = /[a-z]+/;
const numberRegexp = /[0-9]+/;
const symbolRegexp = /[^\p{L}\d\s]/u;

const evaluatePasswordValidations = (value = '') => {
  const validationsPassed = [];

  if (value.length >= PASSWORD_MIN_LENGTH && value.length <= PASSWORD_MAX_LENGTH) {
    validationsPassed.push(PASSWORD_LENGTH_VALIDATION);
  }
  if (uppercaseRegexp.test(value)) {
    validationsPassed.push(PASSWORD_UPPERCASE_VALIDATION);
  }
  if (lowercaseRegexp.test(value)) {
    validationsPassed.push(PASSWORD_LOWERCASE_VALIDATION);
  }
  if (numberRegexp.test(value)) {
    validationsPassed.push(PASSWORD_NUMBER_VALIDATION);
  }
  if (symbolRegexp.test(value)) {
    validationsPassed.push(PASSWORD_SYMBOL_VALIDATION);
  }

  return validationsPassed;
};

export const mapValidationsStatus = (value = '') => {
  const validationsPassed = evaluatePasswordValidations(value);

  return VALIDATIONS.reduce((acc, validation) => {
    acc[validation] = validationsPassed.includes(validation);
    return acc;
  }, {});
};

export const isValidPassword = (value = '') => {
  const validationsPassed = evaluatePasswordValidations(value);

  const isValid = validationsPassed.length === VALIDATIONS.length;
  if (isValid) {
    return true;
  }

  // Return the first validation message that failed
  return ERROR_KEY_TO_TERM_MAP[
    VALIDATIONS.find((validation) => !validationsPassed.includes(validation))
  ];
};
